import {Roles} from './roles';

export enum Authorize {
    CreateUsers = 1,
    Allocator,
    AgencyUsers,
    AgencyContactsReport,
    ViewCaseSensitiveInformation,
    NonAllocator,
    CreateAgencies,
    Campaigns,
    Admins,
    AdoptionProcess,
    DonorProcess,
    ManageAllocators,
    MasterAdmin,
    AllocatorWorkingPage,
    CreateCase,
    ManageAgency,
    AgencyAdmin,
    BulkAgencyPaymentReport,
    FreezeCampaign
}

export interface AuthorizeCollection {
    roles?: Roles[];
    permissions?: string[];
    claims?: string[];
}

export type AuthorizeMap = {
    [key in Authorize]?: AuthorizeCollection;
};

export const authorizeMap: AuthorizeMap = {
    [Authorize.CreateUsers]: {
        roles: [Roles.MasterAdmin, Roles.AgencyAdmin]
    },
    [Authorize.CreateAgencies]: {
        roles: [Roles.MasterAdmin, Roles.CampaignAdmin]
    },
    [Authorize.Allocator]: {
        roles: [Roles.Allocator]
    },
    [Authorize.AgencyContactsReport]: {
        roles: [Roles.MasterAdmin, Roles.CampaignAdmin]
    },
    [Authorize.ViewCaseSensitiveInformation]: {
        roles: [Roles.MasterAdmin, Roles.CampaignAdmin, Roles.AgencyAdmin, Roles.AgencyUser]
    },
    [Authorize.NonAllocator]: {
        roles: [Roles.MasterAdmin, Roles.CampaignAdmin, Roles.AgencyAdmin, Roles.AgencyUser]
    },
    [Authorize.AdoptionProcess]: {
        roles: [Roles.CampaignAdmin, Roles.MasterAdmin]
    },
    [Authorize.DonorProcess]: {
        roles: [Roles.CampaignAdmin, Roles.MasterAdmin]
    },
    [Authorize.Campaigns]: {
        roles: [Roles.MasterAdmin, Roles.CampaignAdmin]
    },
    [Authorize.AgencyUsers]: {
        roles: [Roles.AgencyAdmin, Roles.AgencyUser]
    },
    [Authorize.Admins]: {
        roles: [Roles.MasterAdmin, Roles.CampaignAdmin]
    },
    [Authorize.ManageAllocators]: {
        roles: [Roles.MasterAdmin, Roles.CampaignAdmin]
    },
    [Authorize.MasterAdmin]: {
        roles: [Roles.MasterAdmin]
    },
    [Authorize.AllocatorWorkingPage]: {
        roles: [Roles.MasterAdmin, Roles.CampaignAdmin, Roles.Allocator]
    },
    [Authorize.CreateCase]: {
        roles: [Roles.MasterAdmin, Roles.CampaignAdmin, Roles.AgencyAdmin, Roles.AgencyUser]
    },
    [Authorize.ManageAgency]: {
        roles: [Roles.MasterAdmin, Roles.AgencyAdmin]
    },
    [Authorize.AgencyAdmin]: {
        roles: [Roles.AgencyAdmin]
    },
    [Authorize.BulkAgencyPaymentReport]: {
        roles: [Roles.AgencyAdmin, Roles.MasterAdmin]
    },
    [Authorize.FreezeCampaign]: {
        roles: [Roles.CampaignAdmin, Roles.MasterAdmin]
    },
};
